module.exports = __webpack_public_path__ + "img/33943-522.2c8ca318.jpg";